import postRequest from '../../../postRequest';

/**
 * Invalidates the users Auth token.
 *
 * @param {string} token
 * @returns Object from DB
 */
function postRevokeRefreshToken(token) {
  const endpoint = '/users/revoke-refresh-token';

  const body = new FormData();
  body.append('refreshToken', token);

  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Revoke Refresh Token', null, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postRevokeRefreshToken;
